namespace Roodik.Game
{
	import IBoardModel = Roodik.Game.IBoardModel;
	import ITileInfo = Roodik.Game.ITileInfo;
	import NeighborKey = Roodik.Game.NeighborKey;
	
	export class BoardModel implements IBoardModel
	{
		public static readonly HAS_NO_MOVES : number = 1;
		public static readonly HAS_NO_TILES : number = 2;
		public static readonly TIMES_UP : number = 3;
		public static readonly GAME_COMPLETE : number = 4;

		private _selectedTile : ITileModel;
		private _tiles : Array<ITileModel>;
		private _columns : Array<string>;
		private _reshuffleRunning : boolean = false;
		private _cachedTilesForRemove : Array<ITileModel> = [];
		private _undoHistory : Array<IPairOfTiles> = [];
		private _undoIndex : number = -1;
		private _totalTilesCount : number = 0;
		private _hintIndex : number = 0;

		private _suggestedPair : IPairOfTiles;
		private _tileTypeForReshuffle : string = "blackMark";
		private _reshuffleStrategy : ReshuffleStrategy;
		
		constructor(private _boardData : IBoardData,
		            private _gameEndCallBack : (result : number) => void)
		{
			let tileInfos = this.parseTileInfos();
			this.parseStructure(tileInfos);
			
			this._reshuffleStrategy = new ReshuffleStrategy(this._columns, this.getTilesWhichCanBeMatched.bind(this));
			
			this.reshuffle(true);
		}
		
		public getTilesModels():Array<ITileModel>
		{
			for(var i : number = 0; i < this._tiles.length; i++)
			{
				if(this._tiles[i] != null)
				{
					this._tiles[i].calculatePosition();
				}
			}
			return this._tiles;
		}
		
		private parseTileInfos()
		{
			let allTiles = new Array<ITileInfo>();
			let tiles = this._boardData.tiles;
			for(let i : number = 0; i < tiles.length; i++)
			{
				let countImages = tiles[i].num;
				for(let j : number = 0; j < countImages; j++)
				{
					allTiles.push(tiles[i]);
				}
			}
			
			return allTiles;
		}
		
		private parseStructure(tileInfos : Array<ITileInfo>)
		{
			let structure : IPosition = this._boardData.structure;
			this._columns = [];
			this._tiles = [];
			let index = 0;
			
			for(let z : number = 0; z < structure.z; z++)
			{
				for(let y : number = 0; y < structure.y; y++)
				{
					for(let x : number = structure.x - 1; x >= 0; x--)
					{
						let layer = this._boardData.layers[z];
						let row : string = layer[y];
						let value = row.charAt(x);
						const isTileExist = value == "1";
						let key = x + ":" + y + ":" + z;
						
						if(isTileExist)
						{
							this._tiles[index] = new TileModel(index, key, this._boardData.startPositions, tileInfos[index]);
							index++;
						}
						this._columns[key] = value;
					}
				}
			}
			
			this._totalTilesCount = this._tiles.length;
		}
		
		public selectTile(index : number):boolean
		{
			let incomingIndex : number = index;
			let tiles = this._tiles;
			
			if(this.tileCanSelect(tiles[incomingIndex]))
			{
				if(this._selectedTile == null)
				{
					this._selectedTile = tiles[incomingIndex];
					this._selectedTile.selected = true;
					return true;
				}
				else
				{
					if(this._selectedTile.index != incomingIndex)
					{
						if(this._selectedTile.type == tiles[incomingIndex].type)
						{
							tiles[incomingIndex].selected = true;
							this.matchTiles(this._selectedTile, tiles[incomingIndex]);
						}
						else
						{
							this._selectedTile.selected = false;
							this._selectedTile = tiles[incomingIndex];
							this._selectedTile.selected = true;

							if (this._incorrectMatchCallBack() != null)
							{
								this._incorrectMatchCallBack();
							}

							return true;
						}
					}
				}
			}
			else
			{
				tiles[incomingIndex].showIllegalAnimation();
			}

			return false;
		}
		
		private matchTiles(first : ITileModel, second : ITileModel)
		{
			this.cacheTilesForRemove(first);
			this.cacheTilesForRemove(second);
			this._selectedTile = null;
			this._hintIndex = 0;
			
			if (this._matchCallBack != null)
			{
				this._matchCallBack();
			}
		}
		
		private cacheTilesForRemove(tile : Roodik.Game.ITileModel)
		{
			tile.selected = false;
			this._cachedTilesForRemove = this._cachedTilesForRemove.concat(this._tiles[tile.index]);
		}
		
		public removeTiles(removedCallBack : () => void)
		{
			let removedAnimationFinished : number = 0;
			let needWait : number = this._cachedTilesForRemove.length;
			
			for(var i : number = 0; i < needWait; i++)
			{
				let index = this._cachedTilesForRemove[i].index;
				this._tiles[index].remove(() =>
				{
					removedAnimationFinished++;
					if(removedAnimationFinished == needWait)
					{
						removedCallBack();

						let boardCleared:boolean = this.countExistingTiles() == 0;
						if (!boardCleared)
						{
							this.checkForReshuffle(matchData.first.type);
						}
						this.checkBoardForPlay(boardCleared);
					}
				});
				this._columns[this._cachedTilesForRemove[i].key] = "0";
			}
			
			let matchData = <IPairOfTiles>{
				first:this._cachedTilesForRemove[0],
				second:this._cachedTilesForRemove[1]
			};
			
			this._cachedTilesForRemove = [];
			this._undoHistory.push(matchData);
		}
		
		private checkForReshuffle(matchedType : string)
		{
			if(matchedType == this._tileTypeForReshuffle)
			{
				this.reshuffle(true);
			}
		}
		
		private checkBoardForPlay(boardCleared:boolean)
		{
			if(boardCleared)
			{
				//GAME WON
				this._gameEndCallBack(BoardModel.HAS_NO_TILES);
			}
			else
			{
				if(!this.checkMatchExist())
				{
					//GAME LOSS
					this._gameEndCallBack(BoardModel.HAS_NO_MOVES);
				}
			}
		}
		
		private countExistingTiles() : number
		{
			let count = 0;
			this._tiles.forEach((item : ITileModel) =>
			{
				if(item != null && !item.removed)
				{
					count++;
				}
			});
			return count;
		}
		
		private checkMatchExist() : Boolean
		{
			return this.getPairOfTiles() != null;
		}
		
		public undo()
		{
			if(this._undoHistory.length > 0)
			{
				this.resetSuggested();

				this._hintIndex = 0;
				this._undoIndex = -1;
				
				let popped = this._undoHistory.pop();
				
				this._columns[popped.first.key] = "1";
				this._columns[popped.second.key] = "1";
				
				this._undoIndex = popped.first.index;
				this._undoIndex = popped.second.index;
			}
		}
		
		public hint()
		{
			let pair : IPairOfTiles = this.getPairOfTiles();
			if(pair != null)
			{
				this.makeChangesWithSuggestedPair(pair);
				
				pair.first.highlight();
				pair.second.highlight();
				
				this._hintIndex++;
			}
		}
		
		private getPairOfTiles()
		{
			let sortedMatchTiles = this.getTilesWhichCanBeMatched();
			if(sortedMatchTiles.length != 0)
			{
				if(this._hintIndex >= sortedMatchTiles.length)
				{
					this._hintIndex = 0;
				}
				
				return sortedMatchTiles[this._hintIndex];
			}
			return null;
		}
		
		private makeChangesWithSuggestedPair(pair : Roodik.Game.IPairOfTiles)
		{
			this.resetSuggested();
			this._suggestedPair = pair;
		}
		
		private resetSuggested()
		{
			if(this._suggestedPair != null)
			{
				if(!this._suggestedPair.first.removed)
				{
					this._suggestedPair.first.reset();
				}
				if(!this._suggestedPair.second.removed)
				{
					this._suggestedPair.second.reset();
				}
				this._suggestedPair = null;
			}
		}
		
		private getTilesWhichCanBeMatched() : Array<IPairOfTiles>
		{
			let canMatchTiles : Array<IPairOfTiles> = [];
			var tilesCount : number = this._tiles.length;
			for(var i = 0; i < (tilesCount - 1); i++)
			{
				for(var j = i + 1; j < tilesCount; j++)
				{
					if(this._tiles[i] != null && this._tiles[j] != null &&
					!this._tiles[i].removed && !this._tiles[j].removed)
					{
						if(this._tiles[i].type == this._tiles[j].type)
						{
							if(this.tileCanSelect(this._tiles[i]) && this.tileCanSelect(this._tiles[j]))
							{
								canMatchTiles.push(<IPairOfTiles>{
									first:this._tiles[i],
									second:this._tiles[j]
								});
							}
						}
					}
				}
			}
			
			return canMatchTiles;
		}
		
		private tileCanSelect(tile : ITileModel) : Boolean
		{
			if(tile.selected)
			{
				return false;
			}
			
			if(this.neighborExist(NeighborKey.UP, tile.key))
			{
				return false;
			}
			
			return (!this.neighborExist(NeighborKey.LEFT, tile.key) || !this.neighborExist(NeighborKey.RIGHT, tile.key));
		}
		
		private neighborExist(neighborKey : NeighborKey, key : string) : Boolean
		{
			let arr = key.split(":");
			let _x : number = +arr[0];
			let _y : number = +arr[1];
			let _z : number = +arr[2];
			
			switch(neighborKey)
			{
				case NeighborKey.DOWN:
					return this._columns[_x + ":" + _y + ":" + (_z - 1)] == "1";
				case NeighborKey.UP:
					return this._columns[_x + ":" + _y + ":" + (_z + 1)] == "1";
				case NeighborKey.RIGHT:
					return this._columns[(_x + 1) + ":" + _y + ":" + _z] == "1";
				case NeighborKey.LEFT:
					return this._columns[(_x - 1) + ":" + _y + ":" + _z] == "1";
			}
			
			return false;
		}
		
		public reshuffle(isSolvableProbability:boolean)
		{
			if(!this._reshuffleRunning)
			{
				this.resetSuggested();
				this._reshuffleRunning = true;
				
				this._reshuffleStrategy.shuffle(this._tiles, isSolvableProbability);

				this._hintIndex = 0;
				this._reshuffleRunning = false;
				this._undoHistory = [];
				this._selectedTile = null;
			}
		}
		
		private _matchCallBack:()=>void;
		public matchCallBack(callBack:()=>void)
		{
			this._matchCallBack = callBack;
		}

		private _incorrectMatchCallBack:()=>void;
		public incorrectMatchCallBack(callBack:()=>void)
		{
			this._incorrectMatchCallBack = callBack;
		}

		public get matchedCount() : number { return this._totalTilesCount - this.countExistingTiles(); }
		
		public get selectedTile() : ITileModel { return this._selectedTile; }
		
		public get cachedTilesForRemove() : Array<ITileModel> { return this._cachedTilesForRemove; }
		
		public destroy()
		{
			if (this._tiles != null)
			{
				for(var i : number = 0; i < this._tiles.length; i++)
				{
					if(this._tiles[i] != null)
					{
						this._tiles[i].destroy();
					}
				}
				this._tiles = null;
			}
			
			if (this._reshuffleStrategy != null)
			{
				this._reshuffleStrategy.destroy();
				this._reshuffleStrategy = null;
			}

			this.resetSuggested();

			this._incorrectMatchCallBack = null;
			this._matchCallBack = null;
			this._suggestedPair = null;
			this._undoHistory = null;
			this._cachedTilesForRemove = null;
			this._columns = null;
			this._selectedTile = null;
			this._boardData = null;
			this._gameEndCallBack = null;
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/Model/Board/BoardModel.ts